import { Box, Skeleton } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

const ClassSkeleton = ({ showHeader = true }) => {
  const existLinceseAssessment = useSelector((state) =>
    state?.tenant?.license?.find((license) => license.code === 'assessment')
  );

  return (
    <>
      {showHeader && (
        <Box className='flex flex-nowrap gap-4 pb-4 items-strech justify-center overflow-auto'>
          {Array.from({ length: existLinceseAssessment ? 5 : 2 }).map((_, jndex) => (
            <Skeleton
              key={`card-info-${jndex}`}
              variant='rectangular'
              width='100%'
              height={50}
              className='rounded min-w-100px max-w-150px'
            />
          ))}
        </Box>
      )}
      <Skeleton
        key={`card-info-teachers`}
        variant='rectangular'
        width='100%'
        height={35}
        className='rounded'
      />
      <Box className='flex flex-nowrap gap-4 px-4 py-4 items-strech justify-start overflow-auto'>
        {Array.from({ length: 2 }).map((_, jndex) => (
          <Skeleton
            key={`card-info-teachers-${jndex}`}
            variant='rectangular'
            width='100%'
            height={30}
            className='rounded min-w-100px max-w-150px'
          />
        ))}
      </Box>
      <Skeleton
        key={`card-info-students`}
        variant='rectangular'
        width='100%'
        height={35}
        className='rounded'
      />
      <Box className='flex flex-wrap gap-4 px-4 py-4 items-strech justify-start overflow-auto'>
        {Array.from({ length: 22 }).map((_, jndex) => (
          <Skeleton
            key={`card-info-students-${jndex}`}
            variant='rectangular'
            width='100%'
            height={30}
            className='rounded min-w-100px max-w-150px'
          />
        ))}
      </Box>
      {existLinceseAssessment && (
        <>
          <Skeleton
            key={`card-info-unit-of-learning`}
            variant='rectangular'
            width='100%'
            height={35}
            className='rounded'
          />
          <Box className='flex flex-wrap gap-4 px-4 py-4 items-strech justify-start overflow-auto'>
            {Array.from({ length: 4 }).map((_, jndex) => (
              <Skeleton
                key={`card-info-unit-of-learning-${jndex}`}
                variant='rectangular'
                width='100%'
                height={100}
                className='rounded min-w-150px max-w-200px'
              />
            ))}
          </Box>
        </>
      )}
    </>
  );
};

export default ClassSkeleton;
